import React from 'react';
import { Form, FormGroup, Input } from 'reactstrap';
import { Active, ChataApp_p1, ChataApp_p2 } from '../../../Constant';
import { P } from '../../../AbstractElements';

const PeopleListAndStatus = () => {
  return (
    <>
      <div className='people-list'>
        <div className='search'>
          <Form className='theme-form'>
            <FormGroup>
              <Input className='form-control' type='text' placeholder='Write Status...' />
              <i className='fa fa-pencil'></i>
            </FormGroup>
          </Form>
        </div>
      </div>
      <div className='status'>
        <P className='font-primary f-w-600'>{Active}</P> <hr />
        <P>
          {ChataApp_p1}
          <i className='icofont icofont-emo-heart-eyes font-danger f-20'></i>
          <i className='icofont icofont-emo-heart-eyes font-danger f-20 m-l-5'></i>
        </P>
        <hr />
        <P>
          {ChataApp_p2}
          <i className='icofont icofont-emo-rolling-eyes font-success f-20'></i>
        </P>
      </div>
    </>
  );
};

export default PeopleListAndStatus;
